var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.35262C2 4.55378 2.67157 3.90619 3.5 3.90619H12.5C13.3284 3.90619 14 4.55378 14 5.35262V11.4598C14 12.2586 13.3284 12.9062 12.5 12.9062H3.5C2.67157 12.9062 2 12.2586 2 11.4598V5.35262ZM3 9.08804V11.4598C3 11.726 3.22386 11.9419 3.5 11.9419H12.5C12.7761 11.9419 13 11.726 13 11.4598V9.7309L11.5202 8.30397C11.325 8.11568 11.0084 8.11568 10.8131 8.30397L9.54044 9.53119L9.85355 9.83312C10.0488 10.0214 10.0488 10.3267 9.85355 10.515C9.65829 10.7033 9.34171 10.7033 9.14645 10.515L5.68689 7.17897C5.49162 6.99068 5.17504 6.99068 4.97978 7.17897L3 9.08804ZM9.33333 6.47762C9.33333 6.83266 9.03486 7.12047 8.66667 7.12047C8.29848 7.12047 8 6.83266 8 6.47762C8 6.12258 8.29848 5.83476 8.66667 5.83476C9.03486 5.83476 9.33333 6.12258 9.33333 6.47762Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoIcon);
export default __webpack_public_path__ + "static/media/company-logo-icon.fc7254e7b06c497d4358974833c4fe08.svg";
export { ForwardRef as ReactComponent };